import { create } from 'zustand'

import { ReactCallBackFunction } from 'src/types/CallbackFunction'
import { Filters } from 'src/types/Filters'

interface FilterBarState {
  filtersShapes: {
    filters: Filters
    rawFilters: { [key: string]: any }
    requestFilters: object
  } | null
  dataWarnings: object
  setFiltersShapes: ReactCallBackFunction<FilterBarState['filtersShapes']>
  setDataWarnings: ReactCallBackFunction<FilterBarState['dataWarnings']>
}

const useFilterBarStore = create<FilterBarState>(set => ({
  filtersShapes: null,
  dataWarnings: {},
  setFiltersShapes: filtersShapes =>
    set(state => ({
      ...state,
      filtersShapes:
        typeof filtersShapes === 'function' ? filtersShapes(state.filtersShapes) : filtersShapes,
    })),
  setDataWarnings: dataWarnings =>
    set(state => ({
      ...state,
      dataWarnings:
        typeof dataWarnings === 'function' ? dataWarnings(state.dataWarnings) : dataWarnings,
    })),
}))

export default useFilterBarStore
